import React from 'react';

import { ModalService } from '@biteinc/core-react';

import { MenuFilterPicker } from '../components';

namespace MenuFilterService {
  export function showMenuFilters(): void {
    const hide = ModalService.showCustomModal({
      cssClass: 'menu-filters-modal',
      children: (
        <MenuFilterPicker
          close={() => {
            hide();
          }}
        />
      ),
    });
  }
}

export default MenuFilterService;
